<template>
    <div class="general-information row div-spacing-top">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="order-title">
          General Information
        </div>
      </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top" v-if="Order.RequiredClinicEvent == true">
            <div class="form-group order-div"  :class="{'spinner-disabled': ($route.params.EditOrReuse == '1' || $route.params.EditOrReuse == '2' || $route.params.EditOrReuse == '3')}">
                <label>Clinic/Event</label><span v-if="Order.RequiredClinicEvent == true">*</span>
                <select v-model="ClinicEvent" v-bind:class="{ error_field: ValidationResult.OrderClinicEvent }" @change="ClinicEventChangedEvent" class="form-control" name="clinic" :disabled="($route.params.EditOrReuse == '1' || $route.params.EditOrReuse == '2' || $route.params.EditOrReuse == '3')">
                    <option v-if="ClinicEventList.length == 0" selected disabled>No clinic/event to select..</option>
                    <option v-for="(item, index) in ClinicEventList" v-bind:value="item" selected>{{item.name || item.clinic_Name__c}}</option>
                </select>
                <p class="error-message" v-if="ValidationResult.OrderClinicEvent">{{ValidationResult.OrderClinicEvent}}</p>

                <!-- DEBUG Ready for search function -->
                <!-- https://vue-multiselect.js.org/ -->
                <!-- <label class="typo__label">Clinic/Event</label>
                <multiselect v-model="ClinicEvent" :options="ClinicEventList" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="" label="name" track-by="name" :preselect-first="true" :class="form-control" @change="APIGetSchoolOrganizationList(ClinicEvent.clinicEventId)">
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single form-control" :class="form-control" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect> -->

            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top" v-if="Order.RequiredClinicEvent == true">
            <div class="form-group order-div"  :class="{'spinner-disabled': disable_SchoolOrganization || ($route.params.EditOrReuse == '1' || $route.params.EditOrReuse == '2' || $route.params.EditOrReuse == '3')}">
                <label>School/Organization</label><span v-if="Order.RequiredClinicEvent == true">*</span>
                <a class="pull-right" @click="UpdateCacheAndRefresh()" v-if="!isUpdateCacheAndRefreshLoading && (!($route.params.EditOrReuse == '1' || $route.params.EditOrReuse == '2' || $route.params.EditOrReuse == '3'))"><i class="fa fa-refresh"></i></a>
                <img :src="pageLoader_img" height="30px" width="30px" class="pull-right" v-if="isUpdateCacheAndRefreshLoading">
                <select v-model="SchoolOrganization" v-bind:class="{ error_field: ValidationResult.OrderSchoolOrganization}" @change="UpdateOrder()" class="form-control" :disabled="disable_SchoolOrganization || ($route.params.EditOrReuse == '1' || $route.params.EditOrReuse == '2' || $route.params.EditOrReuse == '3')" name="Organization">
                    <option v-for="(item, index) in SchoolOrganizationList" v-bind:value="item  ">{{item.school_Organization_Name__c}}</option>
                </select>
                <p class="error-message" v-if="ValidationResult.OrderSchoolOrganization">{{ValidationResult.OrderSchoolOrganization}}</p>

                <!-- DEBUG Ready for search function -->
                <!-- https://vue-multiselect.js.org/ -->
                <!-- <label class="typo__label">School/Organization</label>
                <multiselect v-model="SchoolOrganization" :options="SchoolOrganizationList" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="" label="name" track-by="schoolOrganizationId" :preselect-first="true" :class="form-control" @change="UpdateOrder()" :disabled="disable_SchoolOrganization" name="Organization">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single form-control" :class="form-control" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                </multiselect> -->
            </div>
        </div>



        <div v-if="Account.accountType != 1 && accountType != 'Individual'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters order-div">
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Prescribing Doctor*</label>
                        <multiselect :disabled="Order.IsRemakeRedo" v-model="Order.PrescribingDoctorObject" label="eyeDoctorFullName" @close="SetPrescribingDoctorID(Order.PrescribingDoctorObject.salesforceId)" v-bind:class="{ error_field: ValidationResult.OrderEyeDoctorId }" :options="Account.eyeDoctors"  deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" " >
                                <span slot="noResult">No elements found.</span>
                        </multiselect>
                        <p class="error-message" v-if="ValidationResult.OrderEyeDoctorId">{{ValidationResult.OrderEyeDoctorId}}</p>
                    </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 g-pt-30--md g-pt-0">
                    <button tabindex="-1" v-on:click="ShowModal()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mt-3 g-mx-20">Add a Doctor
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Patient First Name*</label>
                <input :disabled="Order.IsRemakeRedo" v-model="Order.PatFirstName" v-bind:class="{ error_field: ValidationResult.OrderPatFirstName }" type="text" class="form-control">
                <p class="error-message" v-if="ValidationResult.OrderPatFirstName">{{ValidationResult.OrderPatFirstName}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Patient Last Name*</label>
                <input :disabled="Order.IsRemakeRedo" v-model="Order.PatLastName" v-bind:class="{ error_field: ValidationResult.OrderPatLastName }" type="text" class="form-control">
                <p class="error-message" v-if="ValidationResult.OrderPatLastName">{{ValidationResult.OrderPatLastName}}</p>
            </div>
        </div>
        <div v-if="Order.ShowExtraStudentFields == true" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Student ID</label>
                <input v-model="Order.StudentID" type="text" class="form-control">
            </div>
        </div>
        <div v-if="Order.ShowExtraStudentFields == true" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group order-div">
                <label>Teacher/Room Number/Grade</label>
                <input v-model="Order.TeacherRoomNum" type="text" class="form-control">
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-bottom">
            <div class="row no-gutters order-div">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Referral Organization*</label>
                        <p>If this patient was referred, please select the primary referral organization. If there was no referral organization involved, please select "Not Applicable".
                        </p>
                        <select :disabled="Order.IsRemakeRedo" v-model="ReferralObject" v-on:change="CheckVouchers()" v-bind:class="{ error_field: ValidationResult.OrderReferralOrg }" class="form-control" style="height: 36.5px;">
                            <option v-for="(vl, index) in VoucherList" v-bind:value="vl">{{vl.name}}</option>
                        </select>
                        <small>By selecting or indicating a Referral Organization for this order, you hereby consent to the disclosure to such Referral Organization of the prescribing doctor's information including, without limitation, to name and number of orders placed and warrant that you are authorized to provide such consent. </small>
                        <p class="error-message" v-if="ValidationResult.OrderReferralOrg">{{ValidationResult.OrderReferralOrg}}</p>
                        <div class="row">
                          <div v-if="isVoucherShown" v-bind:class="{'col-md-12 col-lg-12': !(Order.ReferralOrg == 'Other') , 'col-md-6 col-lg-6': Order.ReferralOrg == 'Other'}" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="form-group">
                              <label>Referral Voucher Number/Code
                                <span v-if="isReferralCodeRequired">*</span>
                                <span v-if="isVoucherCodeValid">
                                    <i class="fa fa-check-circle check_icon"></i>
                                </span>
                              </label>
                              <input v-model="Order.ReferralCode" v-on:blur="ValidateVoucherCode(Order.ReferralCode)" v-bind:class="{ error_field: ValidationResult.OrderReferralCode,  error_field: voucherValidation.OrderReferralCode}" type="text" class="form-control">
                              <p class="error-message" v-if="ValidationResult.OrderReferralCode || voucherValidation.OrderReferralCode">{{ValidationResult.OrderReferralCode}}{{voucherValidation.OrderReferralCode}}</p>
                            </div>
                          </div>
                          <div v-if="Order.ReferralOrg == 'Other'" v-bind:class="{'col-md-12 col-lg-12': !isVoucherShown , 'col-md-6 col-lg-6': isVoucherShown}" class=" col-sm-12 col-xs-12">
                            <div class="form-group">
                              <label>Other Referral Organization
                              </label>
                              <input v-model="Order.OtherReferral" type="text" class="form-control">
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="row"  v-if="Order.IsRemakeRedo">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-check  order-div">
                        <span hidden>
                            <input v-model="Order.IsRemakeRedo" class="form-check-input" type="checkbox" @change="RamakeRedoCheck(Order.IsRemakeRedo)">
                          <span class="g-font-size-18">Remake/Redo <small>(Due to error – i.e. order entry/lab error)</small></span>
                            <span data-balloon="Select this box when submitting a remake or redo order." data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </span>
                        <div class="IsRemakeRedo">
                          <div class="form-group" style="height: 100%;">
                            <label>*Remake Reason:</label>
                            <div class="radio">
                              <label class="radio-inline radio_btn"><input v-model="Order.RemakeRedoReason" type="radio" name="IsLabErrorRedo" value="OTH-LABREDO"> Lab Error</label>
                              <!--If LabRedo is true, the treatment OTH-LABREDO should be sent to VisionWeb and the Order.RemakeRedoReason field should be sent in treatment comments.-->
                              <label class="radio-inline radio_btn"><input v-model="Order.RemakeRedoReason" type="radio" name="IsOrderEntryRedo" value="OTH-OPTERROR"> Order Entry Error</label>
                              <!--If DrRedo is true, the treatment OTH-OPENSOFT should be sent to VisionWeb and the Order.RemakeRedoReason field should be sent in treatment comments.-->
                              <label class="radio-inline radio_btn"><input v-model="Order.RemakeRedoReason" type="radio" name="IsRxChangeRedo" value="OTH-OPENSOFT"> Rx Change</label>
                              <!--If LabRedo is true, the treatment OTH-OPTERROR should be sent to VisionWeb and the Order.RemakeRedoReason field should be sent in treatment comments.-->

                            </div>
                              <p class="error-message" v-if="ValidationResult.OrderRemakeRedoReason">{{ValidationResult.OrderRemakeRedoReason}}</p>
                            <p>Remake Comments*</p><input v-model="Order.RemakeRedoComments" :maxlength="225" type="text" class="form-control">
                              <p class="error-message" v-if="ValidationResult.OrderRemakeRedoComments">{{ValidationResult.OrderRemakeRedoComments}}</p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
              <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12 div-spacing-top">
                <div class="form-group order-div" style="height: 100%;">
                <Label>Select all that apply</Label> (Optional)
                  <div class="form-check">
                        <span class="">
                            <input v-model="Order.IsExamOnly" v-on:change="ClearFirstTimeGlasses(Order.IsExamOnly)" type="checkbox" class="form-check-input" :disabled="Order.IsExtra == true">
                          <span class="g-font-size-18">Exam Only <small>(Patient not issued a prescription)</small></span>
                            <span data-balloon="A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page." data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </span>
                  </div>
                  <div class="form-check" v-if="Order.ShowExtraStudentFields == true">
                        <span class="">
                            <input v-model="Order.IsReferredForEval" type="checkbox" class="form-check-input" :disabled="Order.IsExtra == true">
                          <span class="g-font-size-18">Referred for Further Evaluation</span>
                            <span data-balloon="A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page." data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                <div>
                  <div class="form-group order-div" v-if="Order.IsReferredForEval">
                  <span><b>Referral Reason(s)*</b></span>
                    <div class="form-check">
                        <span class="">
                            <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Amblyopia f/u" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                            <span class="g-font-size-15">Amblyopia f/u <small>(aka Lazy Eye)</small></span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Strabismus f/u" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Strabismus f/u <small>(aka Crossed Eyes)</small></span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Dilated eye health exam" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Dilated eye health exam</span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Cycloplegic refraction" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Cycloplegic refraction</span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Vision check after wearing new glasses" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Vision check after wearing new glasses</span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Vision Therapy" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Vision Therapy</span>
                        </span>
                  </div>
                  <div class="form-check">
                        <span class="">
                          <multi-select-checkbox v-model="Order.ReferralReasonsArray" val="Other" class="form-check-input" :disabled="Order.IsExtra == true" :checked="referralReasonChecked"></multi-select-checkbox>
                          <span class="g-font-size-15">Other</span>
                        </span>
                  </div>
                  <span><b>Referral Notes:</b></span>
                  <input v-model="Order.ReferralNotes" type="text" class="form-control">
                  </div>
            </div>
                        </span>
                  </div>
                   <div class="form-check" v-if="Order.IsExtra">
                        <span class="">
                            <input v-model="Order.IsExtra" type="checkbox" class="form-check-input" disabled>
                          <span class="g-font-size-18">Extra Pair <small>(Back up pair for patient with high Rx) </small></span>
                          <!--If ExtraPair is true, no treatment code is sent to VisionWeb and the patient demographic ID for the original order is stored with this order as well (a new demographic record is not created).-->
                            <span data-balloon="A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page." data-balloon-pos="down" data-balloon-length="large">
                                <i class="fa fa-question-circle-o"></i>
                            </span>
                        </span>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top">
                <div class="form-group order-div" style="height: 100%;">
                  <label>Order Reference/PO</label>
                  <span style="text-align: left" data-balloon="The text in this optional field will be printed on the lab ticket with the completed job and may be used for your internal tracking/sorting purposes. (i.e. School/Event Name, Patient ID, etc)" data-balloon-pos="down" data-balloon-length="large" class="left">
                        <i class="fa fa-question-circle-o"></i>
                  </span>
                  <input :disabled="Order.IsRemakeRedo" v-model="Order.ReferenceNoPo" :maxlength="15" type="text" class="form-control">
                  <!--<small>The text in this optional field will be printed on the lab ticket with the completed job and may be used for your internal tracking/sorting purposes. (i.e. School/Event Name, Patient ID, etc)</small>-->
                </div>
              </div>
            </div>
        </div>
        <div v-if="isModalShown">
            <div class="modal-mask" role="dialog">
                <div class="overlay-mask">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="close_btn" v-on:click="CloseModal()"></div>
                                <div class="row g-mt-20 g-mx-20">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-5 col-md-6 col-sm-7 col-xs-10">
                                                <div class="form-group">
                                                    <label>NPI Number
                                                        <span v-if="!Doctor.UseLicenseNumber">*</span>
                                                        <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                            <i class="fa fa-question-circle-o"></i>
                                                        </span>
                                                    </label>
                                                    <input v-model="Doctor.NpiNumber" v-bind:class="{ error_field: DoctorValidation.EyeDoctorNpiNumber }" type="text" maxlength="10" class="form-control" v-on:keypress="NumberCheck(this.event)" v-on:keyup="ValidateNpiNumberNewDoctor()" v-on:change="changedNPINumber()">
                                                    <p class="error-message" v-if="DoctorValidation.EyeDoctorNpiNumber">{{DoctorValidation.EyeDoctorNpiNumber}}</p>
                                                </div>
                                            </div>

                                            <div class="col-lg-5 col-md-6 col-sm-7 col-xs-10">
                                              <div class="form-group">
                                                <label>Relationship*
                                                    <span v-bind:data-balloon="relationshipTooltip" data-balloon-pos="down" data-balloon-length="large">
                                                        <i class="fa fa-question-circle-o"></i>
                                                    </span>
                                                </label>
                                                <select v-bind:class="{ error_field: DoctorValidation.EyeDoctorRole }"  v-model="Doctor.Role" class="form-control" style="height:36.5px;">
                                                    <!-- <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option> -->
                                                    <option>Self</option>
                                                    <option>Employee</option>
                                                    <option>Contractor</option>
                                                    <option>Unaffiliated</option>
                                                    <option>Other</option>
                                                </select>
                                                <!-- <input type="text" maxlength="10" v-model="Account.Relationship" v-bind:class="{ error_field: AccountValidationResult.AccountRelationship }" class="form-control"> -->
                                                <p class="error-message" v-if="DoctorValidation.EyeDoctorRole">{{DoctorValidation.EyeDoctorRole}}</p>
                                              </div>
                                            </div>


                                        </div>
                                        <div class="row">
                                            <div v-if="!Doctor.UseLicenseNumber" class="clearfix"></div>
                                            <div v-if="Doctor.UseLicenseNumber" class="col-lg-5 col-md-6 col-sm-7 col-xs-10">
                                                <div class="form-group">
                                                    <label>License Number *</label>
                                                    <input maxlength="18" v-model="Doctor.LicenseNumber" v-bind:class="{ error_field: DoctorValidation.EyeDoctorLicenseNumber }" type="text" class="form-control">
                                                    <p class="error-message" v-if="DoctorValidation.EyeDoctorLicenseNumber">{{DoctorValidation.EyeDoctorLicenseNumber}}</p>
                                                </div>
                                            </div>

                                            <div v-if="Doctor.UseLicenseNumber" class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                <div class="form-group">
                                                    <label>State*</label>
                                                    <select v-model="Doctor.State" v-bind:class="{ error_field: DoctorValidation.EyeDoctorState }" class="form-control" style="height:36.5px;">
                                                        <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                                    </select>
                                                    <p class="error-message" v-if="DoctorValidation.EyeDoctorState">{{DoctorValidation.EyeDoctorState}}</p>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-check">
                                                    <input v-on:click="iDontHaveNPINumber()" v-model="useLicenseNumber" type="checkbox" class="form-check-input">
                                                    <p>I don't have an NPI Number</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Doctor First Name*</label>
                                                            <input v-model="Doctor.FirstName" v-bind:class="{ error_field: DoctorValidation.EyeDoctorFirstName }" type="text" class="form-control">
                                                            <p class="error-message" v-if="DoctorValidation.EyeDoctorFirstName">{{DoctorValidation.EyeDoctorFirstName}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Doctor Last Name*</label>
                                                            <input v-model="Doctor.LastName" v-bind:class="{ error_field: DoctorValidation.EyeDoctorLastName }" type="text" class="form-control">
                                                            <p class="error-message" v-if="DoctorValidation.EyeDoctorLastName">{{DoctorValidation.EyeDoctorLastName}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Suffix*</label>
                                                            <select v-model="Doctor.Suffix" v-bind:class="{ error_field: DoctorValidation.EyeDoctorSuffix }" class="form-control"  style="height:36.5px;">
                                                                <option v-for="(value, key) in Suffix" v-bind:value="key">{{key}}</option>
                                                            </select>
                                                            <p class="error-message" v-if="DoctorValidation.EyeDoctorSuffix">{{DoctorValidation.EyeDoctorSuffix}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Doctor's Email Address*</label>
                                                            <input v-model="Doctor.EmailAddress" v-bind:class="{ error_field: DoctorValidation.EyeDoctorEmailAddress }" type="text" class="form-control" oninput="this.value = this.value.toLowerCase()">
                                                            <p class="error-message" v-if="DoctorValidation.EyeDoctorEmailAddress">{{DoctorValidation.EyeDoctorEmailAddress}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10">
                                        <button v-on:click="AddDoctorForThisJobOnly()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10" data-balloon="This doctor’s information will only be used for this order and will not be saved to your account for future use" data-balloon-pos="down" data-balloon-length="large">Use for this job only</button>
                                        <button v-on:click="AddDoctorAndUseNow()" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10" data-balloon="This doctor’s information will be used for this order and will be saved to your account.  It will be available in the “Prescribing Doctor” drop down field" data-balloon-pos="down" data-balloon-length="large">Save and use now</button>
                                        <!-- <div class="row">
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top center">
                                                <button v-on:click="AddDoctor()" class="btn g-color-white g-bg-main g-rounded-10 g-mt-3" data-balloon="This doctor’s information will only be used for this order and will not be saved to your account for future use" data-balloon-pos="down" data-balloon-length="large">Use for this job only</button>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top center">
                                                <button v-on:click="AddDoctor()" class="btn g-color-white g-bg-main g-rounded-10 g-mt-3" data-balloon="This doctor’s information will be used for this order and will be saved to your account.  It will be available in the “Prescribing Doctor” drop down field" data-balloon-pos="down" data-balloon-length="large">Save and use now</button>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading-component v-if="isLoading"></loading-component>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import LoadingComponent from "@/components/shared/LoadingComponent";
import MultiSelectCheckbox from "@/components/shared/MultiSelectCheckbox";
export default {
  props: [
    "Order",
    "ReferralOrgSelect",
    "Suffix",
    "ValidationResult",
    "Account",
    "State",
    "VoucherList",
    "Voucher"
  ],
  components: { Multiselect, LoadingComponent, MultiSelectCheckbox},
  data() {
    return {
      option: null,
      Doctor: {
        UseLicenseNumber: false,
        NpiNumber: null
      },
      useLicenseNumber:false,
      isModalShown: false,
      DoctorValidation: {EyeDoctorNpiNumber:null},
      isLoading: false,
      isVoucherShown: false,
      isReferralCodeRequired: false,
      ReferralObject: null,
      isVoucherCodeValid: false,
      voucherValidation: {},
      originalLenstreatment: [],
      isVoucherRequireValidation: false,

      ClinicEvent: { clinicEventId: '', name: ''},
      ClinicEventList: [],  //   ClinicEventList: [{"clinicEventId":null,"name":null,"clinic_Name__c":null,"start_Date__c":name,"id":0,"validationResult":{}}],
      disable_SchoolOrganization: true,
      SchoolOrganization: {},
      SchoolOrganizationList: [],  //   SchoolOrganizationList: [{"schoolOrganizationId":null,"default_Order_PO__c":null,"school_Organization_Name__c":null,"clinic_Event__c":null," validationResult":{}}],
      isUpdateCacheAndRefreshLoading:false,
      // requireClinicEvents:false,
      falsex:false,
      truex:true,
      checkedProxy:false,
    };
  },
  methods: {
    iDontHaveNPINumber(){
      this.Doctor.UseLicenseNumber = !this.Doctor.UseLicenseNumber;
      if(this.Doctor.UseLicenseNumber == true) this.DoctorValidation.EyeDoctorNpiNumber = null;

    },
    RamakeRedoCheck(val){
        if (val) {
          this.Order.RemakeRedoReason = 'OTH-LABREDO';
          this.Order.RemakeRedoComments = '';
        }
    },
    ClearFirstTimeGlasses(ExamOnlyVal){
      if(this.Order.IsExamOnly == true){this.Order.PatIsFirstTimeGlassesWearer = null};
    },
    SetPrescribingDoctorID(eyeDoctorId){
        this.Order.EyeDoctorId = eyeDoctorId;
    },
    ShowModal() {
      document.body.classList.add("body-overflow");
      this.isModalShown = true;
    },
    CloseModal() {
      this.isModalShown = false;
      document.body.classList.remove("body-overflow");
      this.Doctor.NpiNumber = ""
      this.DoctorValidation.EyeDoctorNpiNumber = null
    },
    AddDoctorForThisJobOnly() {
      if((this.useLicenseNumber == false) && (this.IsNPINumberValid() == false)){
        alert("Please make sure all required fields are complete.")
        return
      }
      var _this = this;
      this.isLoading = true;

      axios
        .post(
          "/Account/EyeDoctor/SaveChangesForOrder/" + this.Account.salesforceId,
          this.Doctor,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(function(response) {
          _this.isLoading = false;
          _this.DoctorValidation = response.data.raw.validationResult;
          if (response.data.isSuccess == true) {
            _this.Account.eyeDoctors = _this.Account.eyeDoctors || [];
            _this.Account.eyeDoctors.push({
              salesforceId: response.data.raw.salesforceId,
              lastName: response.data.raw.lastName,
              firstName: response.data.raw.firstName,
              suffix: response.data.raw.suffix,
              eyeDoctorFullName: response.data.raw.lastName + ", " +  response.data.raw.firstName
            });

            var index = _this.Account.eyeDoctors.findIndex(x => x.salesforceId == response.data.raw.salesforceId);
            _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
            _this.isModalShown = false;
            _this.Order.EyeDoctorId=response.data.raw.salesforceId;
            document.body.classList.remove("body-overflow");
          } else {
                        console.log(error);
                        alert(`An Error occurred.`)
                        _this.isLoading = false;
          }
        })
        .catch(function(error) {
          console.log('ERROR:', error);
        });
    },
    AddDoctorAndUseNow() {
      if((this.useLicenseNumber == false) && (this.IsNPINumberValid() == false)){
        alert("Please make sure all required fields are complete.")
        return
      }
      var _this = this;
      this.isLoading = true;

      axios
        .post(
          "/Account/EyeDoctor/SaveDoctor/" + this.Account.salesforceId,
          this.Doctor,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(function(response) {
          _this.isLoading = false;
          _this.DoctorValidation = response.data.raw.validationResult;
          if (response.data.isSuccess == true) {
            _this.Account.eyeDoctors = _this.Account.eyeDoctors || [];
            _this.Account.eyeDoctors.push({
              salesforceId: response.data.raw.salesforceId,
              lastName: response.data.raw.lastName,
              firstName: response.data.raw.firstName,
              suffix: response.data.raw.suffix,
              eyeDoctorFullName: response.data.raw.lastName + ", " +  response.data.raw.firstName
            });

            var index = _this.Account.eyeDoctors.findIndex(x => x.salesforceId == response.data.raw.salesforceId);
            _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
            _this.isModalShown = false;
            _this.Order.EyeDoctorId=response.data.raw.salesforceId;
            document.body.classList.remove("body-overflow");
          } else if(response.data.isSuccess == false){
              alert(`An error occurred.`)
          }
        })
        .catch(function(error) {
          console.log('ERROR:', error);
        });
    },
    IsNPINumberValid() {
      if(this.Doctor.NpiNumber && this.Doctor.NpiNumber.length == 10){
        return true
      } else {
        return false
      }
    },
    changedNPINumber() {
      if(this.IsNPINumberValid() == true){
        this.DoctorValidation.EyeDoctorNpiNumber = null
      } else {
        this.DoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number"
      }
    },
    GetOrderEyeDoctor() {
      var _this = this;
      if(_this.Order.EyeDoctorId == null) return
            axios.post('/Account/EyeDoctor/GetEyeDoctor/' +  _this.Order.EyeDoctorId, _this.Account)
            .then(function (response) {
                if(response.data.isSuccess == true){
                    _this.Account.eyeDoctors = response.data.raw;
                    var index = _this.Account.eyeDoctors.findIndex(x => x.salesforceId == _this.Order.EyeDoctorId);
                    _this.Order.PrescribingDoctorObject = _this.Account.eyeDoctors[index];
                }
            })
            .catch(function (error) {
                console.log('ERROR:', error);
            });
        },
        NumberCheck(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            }
            else {
                return true;
            }
        },
        CheckVouchers(){
            if(this.ReferralObject){
                this.isVoucherShown = this.ReferralObject.showReferralField;
                this.isReferralCodeRequired = this.ReferralObject.referralFieldRequired;
                this.isVoucherRequireValidation = this.ReferralObject.validationRequired;
                this.Order.ReferralOrg = this.ReferralObject.name;
            }
        },
        CheckSelectedReferralOrg(){
            if(this.Order.ReferralOrg){
                var index = this.VoucherList.findIndex(x => x.name == this.Order.ReferralOrg);
                this.ReferralObject = this.VoucherList[index];
            }
            this.CheckVouchers();
        },
        ValidateNpiNumberNewDoctor() {
            var _this     = this;
            var npiNumber = _this.Doctor.NpiNumber;
            if(npiNumber.length == 10){
                _this.isLoading = true;
                _this.DoctorDetails = { NpiNumber: npiNumber };
                axios.post('/Account/IsNpiNumberValidEyeDoctor/', _this.DoctorDetails)
                .then(response => {
                    if(response.data.isSuccess)
                    {
                        _this.DoctorValidation = {EyeDoctorNpiNumber: null};
                        var details = response.data.raw.results[0];
                        var basicDetails = details.basic;
                        var address      = details.addresses[0];
                        _this.Doctor.FirstName = basicDetails.first_name;
                        _this.Doctor.LastName  = basicDetails.last_name;
                        _this.Doctor.Suffix    = basicDetails.credential;
                        _this.isLoading = false;
                    }
                    else
                    {
                        _this.DoctorValidation = {EyeDoctorNpiNumber: response.data.errorMessage};
                        _this.Doctor.FirstName = null;
                        _this.Doctor.LastName  = null;
                        _this.Doctor.Suffix    = null;
                        _this.isLoading = false;
                    }
                })
                .catch(error => {
                    console.log('ERROR:', error);
                });
            } else {
              _this.DoctorValidation.EyeDoctorNpiNumber = "Invalid NPI Number"
            }
        },
        ValidateVoucherCode(voucherCode){
          if (this.isVoucherRequireValidation) {
            if(voucherCode){
              var _this = this;
              this.isLoading = true;
              this.isVoucherCodeValid = false;
              var data = {
                AssignmentGroup : _this.Order.ReferralOrg,
                VoucherId : voucherCode
              };
              axios.post('/order/IsVoucherCodeValid/',data, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                  _this.isLoading = false;
                  if(response.data.isSuccess == false){
                    _this.voucherValidation.OrderReferralCode = response.data.errorMessage;
                  }else{
                    _this.isVoucherCodeValid = true
                    _this.voucherValidation = {};
                    _this.Voucher.Payment = response.data.raw.payment;

                  }

                })
                .catch(function (error) {
                  console.log('ERROR:', error);
                });
            }else{
              this.voucherValidation = {};
            }
          }else{
            this.voucherValidation = {};
          }

        },





         // EPE-145
            APIGetClinicEventList(refresh = true) {
                  var _this = this;
                  _this.isUpdateCacheAndRefreshLoading = true
                  let list = JSON.parse(localStorage.getItem("ClinicEventList")) || []
                  if((list.length > 0) && (refresh == false)){
                    // console.log("APIGetClinicEventList get from cache")
                    _this.ClinicEventList = JSON.parse(localStorage.getItem("ClinicEventList"));
                    if(_this.ClinicEventList && _this.ClinicEventList.length == 1) _this.InitiateClinicEventSelectObj(_this.ClinicEventList);
                    if(_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateClinicEventSelectObj();
                    _this.isUpdateCacheAndRefreshLoading = false
                  } else {
                  // console.log("APIGetClinicEventList get from API")
                  axios.get('/Order/GetClinicEventList/'+localStorage.getItem("portalUserSalesforceId"), {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                  .then(function (response) {
                        _this.isUpdateCacheAndRefreshLoading = false
                        _this.UpdateClinicEventList(response.data.raw)
                        console.log(response.data.raw)
                        if(response.data.raw && response.data.raw.length == 1) _this.InitiateClinicEventSelectObj(response.data.raw);
                        if(_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) _this.UpdateClinicEventSelectObj();

                  })
                  .catch(function (error) {
                        console.log('ERROR:', error);
                  });
                  }
            },

            APIGetSchoolOrganizationList(id = 0, refresh = true) {
              // console.log("APIGetSchoolOrganizationList", id, refresh)
                  var _this = this;
                  _this.isUpdateCacheAndRefreshLoading = true
                  let list = JSON.parse(localStorage.getItem(`SchoolOrganizationList_${id}`)) || []
                  if((list.length > 0) && (refresh == false)){
                    // console.log("APIGetSchool OrganizationList get from cache")
                    _this.SchoolOrganizationList = JSON.parse(localStorage.getItem(`SchoolOrganizationList_${id}`));
                    _this.disable_SchoolOrganization = false
                    if(_this.SchoolOrganizationList && _this.SchoolOrganizationList.length == 1) _this.InitiateSchoolOrganizationObj(_this.SchoolOrganizationList);
                    if(_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateSchoolOrganizationObj();
                    _this.isUpdateCacheAndRefreshLoading = false
                    this.UpdateOrder()
                  } else {
                  // console.log("APIGetSchool OrganizationList get from API")
                  axios.get('/Order/GetSchoolOrganizationList/'+id, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                  .then(function (response) {
                        _this.UpdateSchoolOrganizationList(id, response.data.raw)
                        _this.disable_SchoolOrganization = false
                        if(response.data.raw && response.data.raw.length == 1) _this.InitiateSchoolOrganizationObj(response.data.raw);
                        if(_this.$route.params.EditOrReuse != null && _this.$route.params.EditOrReuse != undefined) this.UpdateSchoolOrganizationObj();
                        _this.isUpdateCacheAndRefreshLoading = false
                        _this.UpdateOrder()
                  })
                  .catch(function (error) {
                        // console.log("Cannot get organization list.")
                        _this.isUpdateCacheAndRefreshLoading = false
                        console.log('ERROR:', error);
                  });
                  }
            },
            ClinicEventChangedEvent: function ClinicEventChangedEvent(e){
              // console.log("ClinicEventChangedEvent", this.ClinicEvent)
              if(this.ClinicEvent && this.ClinicEvent.clinicEventId){
                this.APIGetSchoolOrganizationList(this.ClinicEvent.clinicEventId, false)
              } else {
                console.log("ERROR: no updating clinic")
              }
            },
            UpdateCacheAndRefresh(){
              this.Order.ClinicEvent = null
              this.SchoolOrganization = null
              // this.ClinicEvent = null
              this.Order.SchoolOrganization = null
              this.ClinicEventList = []
              this.SchoolOrganizationList = []
              this.disable_SchoolOrganization = true

              localStorage.removeItem("ClinicEventList")
              var arr = []; // Array to hold the keys
              // Iterate over localStorage and insert the keys that meet the condition into arr
              for (var i = 0; i < localStorage.length; i++){
                  if (localStorage.key(i).substring(0,23) == 'SchoolOrganizationList_') {
                      arr.push(localStorage.key(i));
                  }
              }
              // Iterate over arr and remove the items by key
              for (var i = 0; i < arr.length; i++) {
                  localStorage.removeItem(arr[i]);
              }
              var _this = this
              setTimeout(function(){ _this.APIGetClinicEventList(true); }, 444);
            },
            UpdateOrder(){
              this.Order.ClinicEvent = this.ClinicEvent.clinicEventId;
              this.Order.SchoolOrganization = this.SchoolOrganization.schoolOrganizationId;
              this.Order.ClinicEventName = this.ClinicEvent.name;
              this.Order.SchoolOrganizationName = this.SchoolOrganization.school_Organization_Name__c;
              this.Order.ReferenceNoPo = this.SchoolOrganization.default_Order_PO__c;
            },
            UpdateClinicEventList(val){
                  this.ClinicEventList = val
                  localStorage.setItem("ClinicEventList", JSON.stringify(val));
            },
            UpdateSchoolOrganizationList(id, val){
                  this.SchoolOrganizationList = val
                  localStorage.setItem(`SchoolOrganizationList_${id}`, JSON.stringify(val));
            },
            InitiateSchoolOrganizationObj(list){
                  this.SchoolOrganization = list[0]
            },
            InitiateClinicEventSelectObj(list){
                  this.ClinicEvent = list[0]
                  this.APIGetSchoolOrganizationList(list[0].clinicEventId, false)
            },
            UpdateSchoolOrganizationObj(){
                  let index = this.SchoolOrganizationList.findIndex(x => x.schoolOrganizationId === this.Order.SchoolOrganization);
                  this.disable_SchoolOrganization = false
                  this.SchoolOrganization = index > -1 ? this.SchoolOrganizationList[index] : null
            },
            UpdateClinicEventSelectObj(){
              if(this.ClinicEventList && this.ClinicEventList.length > 0){
                if(this.Order.ClinicEvent && this.Order.ClinicEvent != ""){
                  let index = this.ClinicEventList.findIndex(x => x.clinicEventId === this.Order.ClinicEvent);
                        this.ClinicEvent = index > -1 ? this.ClinicEventList[index] : null
                        this.APIGetSchoolOrganizationList(this.Order.ClinicEvent, false)
                  }
                  }
            },
            SetCustomUserPermissionFlag(){
              // alert("_this.Order.RequiredClinicEvent" + this.Order.RequiredClinicEvent)
              // let customUserPermissionFlag = localStorage.getItem("customUserPermissionFlag");
              // this.requireClinicEvents = customUserPermissionFlag.includes("Show Clinics and Schools");
              // this.requireClinicEvents = this.Order.RequiredClinicEvent
            },
    },
    created(){
      let AccountType = localStorage.getItem("accountType");
        this.CheckSelectedReferralOrg();
        if(!this.Account.eyeDoctors){
          this.Account.eyeDoctors = [];
        }
        if(this.Account.accountType == 3 && (this.Order.ReferralOrg == null || this.Order.ReferralOrg == '')){
          this.ReferralObject = this.VoucherList[0]
          this.isVoucherShown = this.ReferralObject.showReferralField;
          this.isReferralCodeRequired = this.ReferralObject.referralFieldRequired;
          this.isVoucherRequireValidation = this.ReferralObject.validationRequired;
          this.Order.ReferralOrg = this.ReferralObject.name;
        }

      // this.APIGetClinicEventList(false);
      // console.log("created::", this.$route.params)
      this.SetCustomUserPermissionFlag();
    },
    mounted:function(){
      // console.log("mounted::", this.$route.params)
      if(this.$route.params.EditOrReuse != null || this.$route.params.EditOrReuse != undefined){
        //  not working in UI
        // this.ClinicEvent.clinicEventId = this.Order.ClinicEvent
        // this.ClinicEvent.name = this.Order.ClinicEventName
        // this.SchoolOrganization.schoolOrganizationId = this.Order.SchoolOrganization,
        // this.SchoolOrganization.school_Organization_Name__c = this.Order.SchoolOrganizationName

        // if in the list, set the index
        // if not in list, set
        this.ClinicEventList = JSON.parse(localStorage.getItem("ClinicEventList"));
        if(this.ClinicEventList == null) this.ClinicEventList = []
        let indexC = this.ClinicEventList.findIndex(x => x.clinicEventId === this.Order.ClinicEvent);
        if((this.ClinicEventList[0] == null) || (indexC == -1)){
          this.ClinicEventList.unshift({
            clinicEventId : this.Order.ClinicEvent,
            name: this.Order.ClinicEventName
          })
          this.ClinicEvent = this.ClinicEventList[0]
        } else {
          this.ClinicEvent = this.ClinicEventList[indexC]
        }
        console.log(localStorage)
        this.SchoolOrganizationList = JSON.parse(localStorage.getItem(`SchoolOrganizationList_${this.Order.ClinicEvent}`));
        if(this.SchoolOrganizationList == null) this.SchoolOrganizationList = []
        let indexO = this.SchoolOrganizationList.findIndex(x => x.schoolOrganizationId === this.Order.SchoolOrganization);
        if((this.SchoolOrganizationList[0] == null) || (indexO == -1)){
              this.SchoolOrganizationList.unshift({
                schoolOrganizationId : this.Order.SchoolOrganization,
                school_Organization_Name__c: this.Order.SchoolOrganizationName
              })
          this.SchoolOrganization = this.SchoolOrganizationList[0]
        } else {
          this.SchoolOrganization = this.SchoolOrganizationList[indexO]
        }
          if(this.$route.params.EditOrReuse == '0'){
            this.disable_SchoolOrganization = false
          }
        } else {
          // set list in create
        this.APIGetClinicEventList(false);
      }

        this.GetOrderEyeDoctor();
    },
    // InternationalMission(value){
    //         this.Order.IsInternationalMission = value;
    // },
    // RemakeRedo(value){
    //         this.Order.IsRemakeRedo = value;
    // },
}
</script>



// WEBPACK FOOTER //
// GeneralInformation.vue?871550e6